import { createSlice } from '@reduxjs/toolkit'

const { reducer, actions } = createSlice({
    name: 'period',
    initialState: {
        period: 'today'
    },
    reducers: {
        update(state, action) {
            state.period = action.payload;
        },
    }
})

export { actions as periodActions };
export { reducer as periodReducer };